var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ListItem, TabButton } from './subcomponents';
const Tab = (_a) => {
    var { handleTabClick, activePanel, label, index, className } = _a, props = __rest(_a, ["handleTabClick", "activePanel", "label", "index", "className"]);
    const [showActiveStyles, setShowActiveStyles] = React.useState(activePanel === index);
    const shouldShowActiveStyles = () => {
        setShowActiveStyles(activePanel === index);
    };
    React.useEffect(shouldShowActiveStyles, [activePanel, index]);
    return (React.createElement(ListItem, Object.assign({ showActiveStyles: showActiveStyles, className: className }, props, { onClick: () => {
            handleTabClick(index);
        } }),
        React.createElement(TabButton, { showActiveStyles: showActiveStyles }, label)));
};
export default Tab;
